import client from './client';

/**
 * List available sheet tabs from a Google Sheets URL
 */
export async function listSheets(url) {
  const response = await client.post('/api/import/list-sheets', { url });
  return response.data;
}

/**
 * Parse Google Sheets URL and fetch data
 */
export async function parseGoogleSheets(url, sheetName, gid) {
  const response = await client.post('/api/import/parse-sheets', { url, sheetName, gid });
  return response.data;
}

/**
 * Detect column types from data
 */
export async function detectColumns(headers, sampleRows) {
  const response = await client.post('/api/import/detect-columns', { headers, sampleRows });
  return response.data;
}

/**
 * Check for duplicate URLs
 */
export async function checkDuplicates(project_id, urls) {
  const response = await client.post('/api/import/check-duplicates', { project_id, urls });
  return response.data;
}

/**
 * Validate and auto-fix URLs
 */
export async function validateUrls(urls) {
  const response = await client.post('/api/import/validate-urls', { urls });
  return response.data;
}
